import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "92pt",
  height: "92pt",
  viewBox: "0 0 92 92"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", { d: "M0 .113h91.887V92H0Zm0 0" })
      ])
    ], -1),
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        d: "M90.156 41.965 50.036 1.848a5.92 5.92 0 0 0-8.372 0l-8.328 8.332 10.566 10.566a7.03 7.03 0 0 1 7.23 1.684 7.03 7.03 0 0 1 1.669 7.277l10.187 10.184a7.03 7.03 0 0 1 7.278 1.672 7.04 7.04 0 0 1 0 9.957 7.05 7.05 0 0 1-9.965 0 7.04 7.04 0 0 1-1.528-7.66l-9.5-9.497V59.36a7.04 7.04 0 0 1 1.86 11.29 7.04 7.04 0 0 1-9.957 0 7.04 7.04 0 0 1 0-9.958 7.1 7.1 0 0 1 2.304-1.539V33.926a7.05 7.05 0 0 1-3.82-9.234l-10.418-10.42L1.73 41.777a5.925 5.925 0 0 0 0 8.371L41.852 90.27a5.925 5.925 0 0 0 8.37 0l39.934-39.934a5.925 5.925 0 0 0 0-8.371",
        style: {"stroke":"none","fill-rule":"nonzero","fill":"#f03c2e","fill-opacity":"1"}
      })
    ], -1)
  ])))
}
export default { render: render }